import { XpoDialogRef } from '@xpo/common';

import { Component } from '@angular/core';

@Component({
    selector: 'confirm-dialog',
    template: `
    <dialog-header>
    <dialog-header-title>{{title}}</dialog-header-title>
    <dialog-header-actions>
    </dialog-header-actions>
    </dialog-header>

    <dialog-content>
        <p>{{ message }}</p>
    </dialog-content>

    <dialog-actions>
        <div style="padding:10px"><a (click)="dialogRef.close()" xpo-btn>Cancel</a></div>
        <div style="padding:10px"><a (click)="dialogRef.close(true)" xpo-btn>OK</a></div>
    </dialog-actions>
    `,
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialog {

    public title: string;
    public message: string;

    constructor(public dialogRef: XpoDialogRef<ConfirmDialog>) {

    }
}



// WEBPACK FOOTER //
// ./src/core/dialogs/confirm/confirm-dialog.component.ts